<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import {
  assignmentComputed,
  assignmentListMethod,
  authComputed,
  commomMethod,
} from '@state/helpers'
import formatDate from '@utils/format-date'

export default {
  page: {
    title: 'Assignment Detail',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      assignmentList: [],
    }
  },
  computed: {
    ...assignmentComputed,
    ...authComputed,
  },
  mounted() {
    this.getListOfAssignments()
  },
  methods: {
    ...assignmentListMethod,
    ...commomMethod,

    // Get list of all assignments role wise
    getListOfAssignments() {
      var assignmentId = this.$route.params.id
      this.getAssignmentDataById(assignmentId)
        .then((assignmentList) => {
          this.assignmentList = assignmentList
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },

    formatDates(date) {
      return formatDate(date)
    },

    getURL(link) {
      this.fetchSignedURL(link)
        .then((data) => {
          this.isDownloading = false
          window.open(data, '_blank')
        })
        .catch((error) => {
          this.isDownloading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <a
              href="/assignment-list"
              style="margin-left:20px"
              class="btn btn-primary btn-back"
            >
              Back
            </a>
            <div v-if="assignmentList.assignment" class="row">
              <div class="col-md-7">
                <div>
                  <strong>Title</strong>
                  <p>{{ assignmentList.assignment.title }}</p>
                </div>
                <div>
                  <strong>Description</strong>
                  <p>{{ assignmentList.assignment.description }}</p>
                </div>
                <div>
                  <strong>Deadline</strong>
                  <p>{{ formatDates(assignmentList.assignment.deadline) }}</p>
                </div>
                <div>
                  <strong>Total Assigned Students</strong>
                  <p>{{ assignmentList.response.length }}</p>
                </div>
                <div>
                  <strong>Total Response</strong>
                  <p>{{ assignmentList.total_submit }}</p>
                </div>
              </div>
              <div class="col-md-5">
                <div>
                  <strong>Attached Document</strong>
                  <ul>
                    <li
                      v-for="item in assignmentList.assignment.document"
                      :key="item"
                    >
                      <a href="#" @click="getURL('assignments/' + item)">{{
                        item
                      }}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-md-12">
                <div>
                  <strong>Students Response</strong>
                  <div style="overflow: auto;">
                    <table class="table b-table table-bordered">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Attachment</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in assignmentList.response"
                          :key="item.id"
                        >
                          <td>{{ item.name }}</td>
                          <td>{{ item.email }}</td>
                          <td>
                            <ul v-if="item.assignment_response.length >= 1">
                              <li
                                v-for="res in item.assignment_response[0]
                                  .document"
                                :key="res"
                                class="ml-2"
                              >
                                <a
                                  href="#"
                                  @click="
                                    getURL('assignments-responses/' + res)
                                  "
                                  >{{ res }}</a
                                >
                              </li>
                            </ul>
                            <p v-else>Not Uploaded Yet</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-back {
  margin-bottom: 20px;
  margin-left: 0 !important;
}
</style>
